import StopAddress from './styled';

export default StopAddress;
